import { Link } from "react-router-dom";

const STAT_ROWS = [["ppg", "PPG"], ["rpg", "RPG"], ["apg", "APG"], ["fg3_pct", "3P%", "%"]];
const STATUS_ORDER = ["out", "doubtful", "questionable"];
const fmt = (v, suffix = "") => (v == null ? "—" : `${v}${suffix}`);

export function Comparison({ data, period, game }) {
  const rows = data?.[period];
  if (!rows) return <p className="tv-empty">Loading comparison…</p>;
  if (!rows.away.games && !rows.home.games) return <p className="tv-empty">No games stored yet for these teams.</p>;
  return (
    <div className="gc-comp" data-testid="gc-comparison">
      <div className="gc-comp-head">
        <span><img src={game.away_logo} alt="" />{game.away_code}<small>{rows.away.games} G</small></span>
        <span><small>{rows.home.games} G</small>{game.home_code}<img src={game.home_logo} alt="" /></span>
      </div>
      {STAT_ROWS.map(([k, label, suffix]) => {
        const a = rows.away[k], h = rows.home[k];
        const max = Math.max(a ?? 0, h ?? 0, 1);
        return (
          <div className="gc-comp-row" key={k} data-testid={`gc-comp-${k}`}>
            <b className={a != null && h != null && a > h ? "is-lead" : ""}>{fmt(a, suffix)}</b>
            <span className="gc-bar is-away"><i style={{ width: `${(100 * (a ?? 0)) / max}%` }} /></span>
            <em>{label}</em>
            <span className="gc-bar is-home"><i style={{ width: `${(100 * (h ?? 0)) / max}%` }} /></span>
            <b className={a != null && h != null && h > a ? "is-lead" : ""}>{fmt(h, suffix)}</b>
          </div>
        );
      })}
    </div>
  );
}

export function Leaders({ leaders, game, live }) {
  if (!leaders?.away?.length && !leaders?.home?.length) return null;
  return (
    <div className="gc-section gc-leaders" data-testid="gc-leaders">
      <div className="gc-section-head"><h3>{live ? "Live leaders" : "Game leaders"}</h3>{live && <span className="gc-live-dot">LIVE</span>}</div>
      <div className="gc-leaders-grid">
        {["away", "home"].map((side) => (
          <div key={side} className="gc-leaders-team">
            <div className="gc-leaders-code"><img src={game[`${side}_logo`]} alt="" />{game[`${side}_code`]}</div>
            {(leaders[side] || []).map((l) => (
              <Link key={l.stat} className="gc-leader" to={`/player/${l.player_id}?game=${game.id}`} data-testid={`gc-leader-${side}-${l.stat.toLowerCase()}`}>
                <span className="gc-face"><img src={l.photo} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} /></span>
                <span className="gc-pname">{l.name}</span>
                <b>{l.value}</b><em>{l.stat}</em>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

function Absences({ items }) {
  const groups = STATUS_ORDER.map((s) => [s, items.filter((x) => (x.status || "").toLowerCase() === s)])
    .concat([["other", items.filter((x) => !STATUS_ORDER.includes((x.status || "").toLowerCase()))]])
    .filter(([, xs]) => xs.length);
  if (!groups.length) return <p className="gc-muted">No reported absences.</p>;
  return groups.map(([s, xs]) => (
    <div key={s} className="gc-abs-group">
      {xs.map((x) => (
        <div className="gc-abs" key={`${x.player_id || x.name}-${x.status}`}>
          <i className={`gc-dot is-${s}`} /><span>{x.name}</span><b className={`is-${s}`}>{x.status}</b>
        </div>
      ))}
    </div>
  ));
}

export function TeamLineup({ team, gameId, side }) {
  return (
    <section className="gc-team" data-testid={`gc-lineup-${side}`}>
      <header>
        <img src={team.logo} alt="" />
        <div><b>{team.code} <small>({side.toUpperCase()})</small></b><small>{team.record || "—"}</small></div>
      </header>
      {team.lineup_source && <small className="gc-muted" data-testid={`gc-lineup-source-${side}`}>Expected five · {{ nba: "NBA.com", rotowire: "RotoWire", manual: "NBACUBE admin" }[team.lineup_source] || team.lineup_source}</small>}
      {team.starters.length ? team.starters.map((p) => (
        <Link className="gc-player" key={p.player_id} to={`/player/${p.player_id}?game=${gameId}`} data-testid={`gc-starter-${p.player_id}`}>
          <span className="gc-jersey">{p.jersey ?? "—"}</span>
          <span className="gc-face">{p.photo && <img src={p.photo} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />}</span>
          <span className="gc-pname">{p.name}</span>
          <span className="gc-pos">{p.position || "—"}</span>
        </Link>
      )) : <p className="gc-muted">Starting five not available yet.</p>}
      <div className="gc-abs-title">{team.code} out / questionable</div>
      <Absences items={team.may_not_play || []} />
    </section>
  );
}
